<template>
  <div>
    <div class="slide-modal-title">Get your personal cover</div>
    <ValidationObserver>
      <form @submit.prevent="onSubmit">
        <div class="form-group control has-icons-right">
          <ValidationProvider
            ref="ageObserver"
            v-slot="{ errors }"
            rules="required|min_age:16|max_age:120"
          >
            <input
              id="age"
              v-model="riskFactor.age"
              :class="{ 'is-danger': errors[0] }"
              type="number"
              class="input"
              pattern="\d*"
              required
            />
            <label class="form-control-placeholder" for="age"> Your age </label>
            <span v-if="errors[0]" class="icon is-danger is-small is-right">
              <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
            </span>
            <span :class="{ 'is-danger': errors[0] }" class="help">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>

        <div class="form-group control has-icons-right">
          <ValidationProvider
            ref="postcodeObserver"
            v-slot="{ errors }"
            rules="required"
          >
            <input
              id="postcode"
              v-model="riskFactor.postcode"
              :class="{ 'is-danger': errors[0] }"
              type="text"
              class="input"
              required
            />
            <label class="form-control-placeholder" for="postcode">
              Your postcode
            </label>
            <span v-if="errors[0]" class="icon is-danger is-small is-right">
              <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
            </span>
            <span :class="{ 'is-danger': errors[0] }" class="help">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </div>

        <button
          :class="{ 'is-loading': $nuxt.$loading.get() }"
          type="submit"
          class="button ps-button is-fullwidth call-to-action"
        >
          Get my quote
        </button>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  name: 'RiskFactors',
  data: () => {
    return {
      riskFactor: {
        age: '',
        postcode: '',
      },
      showDiscountInput: false,
    }
  },
  computed: {},
  created() {},
  methods: {
    async validate() {
      const age = await this.$refs.ageObserver.validate()
      const postcode = await this.$refs.postcodeObserver.validate()
      const isValid = age.valid && postcode.valid
      if (isValid) {
        this.$emit('continue', this.riskFactor)
      } else {
        console.log('not valid')
      }
    },
    onSubmit() {
      this.validate()
    },
  },
}
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 100%;
}
.discount {
  padding-bottom: 5px;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
}
.display-discount {
  margin-top: 20px;
  color: $ps-primary;
}
</style>
